// Сборка `ng build --configuration app`: админка тестового сервера мобильного приложения
// (Go keremet-go, ветка app). Сайт — admin-app.keremetsolution.kz (предварительно).
export const environment = {
  production: false,
  apiUrl: 'https://api-app.keremetsolution.kz/api',
  // Старый справочник «Ингредиенты» (tech_cards): в api-app рецептура только в техкартах v2 (решение 09.10);
  // раздел /admin/ingredients и кнопка «Общие ингредиенты» в этой сборке убраны (Д-T20-6, решение 10.10).
  legacyIngredients: false,
  // Старое «Планирование» (/plans): в api-app задания цеха строятся только из заказов (Д-T20-1, решение 10.10).
  legacyPlans: false
};
